import type { FunctionComponent, PropsWithChildren } from 'react';
import { createContext } from 'react';

import { ErrorBoundary } from '@trello/error-boundaries';

import { MoonshotSteps } from './moonshotCampaign';
import type { MoonshotContextState } from './types';
import { useMoonshotContext } from './useMoonshotContext';

export const moonshotContextDefaultValue: MoonshotContextState = {
  currentStep: MoonshotSteps.CREATE_TEAM,
  // @ts-expect-error TS(2322): Type 'void' is not assignable to type 'Promise<void>'.
  onSubmit: () => {},
  // @ts-expect-error TS(2322): Type 'void' is not assignable to type 'Promise<void>'.
  onDismiss: () => {},
  setOrgId: () => {},
  orgId: '',
  loading: true,
  idEnterprise: null,
  isEnterprise: false,
  isFreeTrial: false,
  // @ts-expect-error TS(2322): Type 'undefined' is not assignable to type '{...}'
  analyticsAttributes: undefined,
  setHasCreatedFirstWorkspace: () => {},
};

export const MoonshotContext = createContext<MoonshotContextState>(
  moonshotContextDefaultValue,
);

export const MoonshotProvider: FunctionComponent<
  PropsWithChildren<unknown>
> = ({ children }) => {
  const context = useMoonshotContext();
  return (
    <ErrorBoundary
      tags={{ ownershipArea: 'trello-web-eng', feature: 'moonshot' }}
    >
      <MoonshotContext.Provider value={context}>
        {children}
      </MoonshotContext.Provider>
    </ErrorBoundary>
  );
};
